[
    {
        "1001":"userExist",
        "1012":"MULTI_DEVICE",
        "1023":"panelCountryRelation",
        "1034":"proxyVPNMessage",
        "1045":"MULTI_IP",
        "1056":"notValidUser",
        "1067":"invalidEmail",
        "1078":"emailScore",
        "1089":"notAvailableLocation",
        "1155":"referLinkExpire",
        "1166": "invalidPromoCode",
        "1177": "promoCodeExpire",
        "1188": "invalidPromoCode",
        "1199": "referLimitExceed",
        "1210":"alreadyAdded",
        "1221": "manageCartOfferReject",
        "1232":"manageCartOfferReject"
    }
]